export interface ParsedAslBelgisiMark {
  raw: string;
  gtin: string;
  serial: string;
  isValid: boolean;
}

/**
 * Парсер кодов маркировки системы Asl Belgisi (Узбекистан).
 * Формат GS1: (01)GTIN(21)SERIAL...
 * Поддерживает разделители GS1 (\u001d / ASCII 29).
 */
export function parseAslBelgisi(rawCode: string): ParsedAslBelgisiMark {
  const clean = rawCode.trim();

  // Регулярное выражение для извлечения GTIN (14 цифр) и серийного номера.
  const gtinMatch = clean.match(
    /(?:01)?(\d{14})(?:21)?([a-zA-Z0-9!"%&'()*+,\-./:;<=>?_]{6,13})/
  );

  if (gtinMatch && gtinMatch[1] && gtinMatch[2]) {
    return {
      raw: clean,
      gtin: gtinMatch[1],
      serial: gtinMatch[2],
      isValid: true,
    };
  }

  // Fallback: упрощённая валидация, если длина кода >= 20 символов.
  if (clean.length >= 20) {
    return {
      raw: clean,
      gtin: clean.slice(0, 14),
      serial: clean.slice(14, 21),
      isValid: true,
    };
  }

  return {
    raw: clean,
    gtin: '',
    serial: '',
    isValid: false,
  };
}
